import { useState, useEffect } from "react";

function UseImagesLoaded(selector, count = 3) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const images = Array.from(document.querySelectorAll(selector));
    if (images.length === 0) {
      setIsReady(true);
      return;
    }

    let loaded = 0;
    const targetCount = Math.min(count, images.length);

    const checkLoaded = () => {
      loaded++;
      if (loaded >= targetCount) {
        setIsReady(true);
      }
    };

    images.slice(0, targetCount).forEach((img) => {
      if (img.complete) {
        checkLoaded();
      } else {
        img.addEventListener("load", checkLoaded, { once: true });
        img.addEventListener("error", checkLoaded, { once: true });
      }
    });
  }, [selector, count]);

  return isReady;
}

export default UseImagesLoaded;